// extracted by mini-css-extract-plugin
export default {"tip":"tip-module___tip___f6b57f99"};